import { seededRandom } from '@libs/random';
import { CollapseIcon } from '@ui/components/CollapseIcon';
import { HorizontalScroll } from '@ui/components/HorizontalScroll';
import { Table, TableCell, TableRow } from '@ui/components/Table';

import startListStyles from './StartList.module.css';
import styles from './StartListSkeleton.module.css';

export function StartListSkeleton({ rowCount, isTeam }: { rowCount: number; isTeam?: boolean }) {
  const rows = Array.from({ length: rowCount }, (_, i) => i);

  return (
    <HorizontalScroll>
      <Table className={startListStyles.participantsList}>
        <TableRow header>
          <TableCell className={startListStyles.numColumn} />
          <TableCell className={startListStyles.nameColumn} colSpan={2}>
            Имя
          </TableCell>
          <TableCell>Рейтинг</TableCell>
        </TableRow>

        {rows.map((i) => (
          <TableRow key={i} hoverable className={isTeam ? startListStyles.teamRow : undefined}>
            <TableCell>{i + 1}</TableCell>
            <TableCell
              className={isTeam ? startListStyles.teamColumn : startListStyles.nameColumn}
              colSpan={2}
            >
              <div className={startListStyles.playerNameContainer}>
                <span className={styles.skeleton} style={{ width: 100 + seededRandom(i) * 80 }} />
              </div>
            </TableCell>
            <TableCell>
              {isTeam ? (
                <CollapseIcon className={styles.collapse} />
              ) : (
                <span className={styles.skeleton} style={{ width: 33 }} />
              )}
            </TableCell>
          </TableRow>
        ))}
      </Table>
    </HorizontalScroll>
  );
}
